import instance from "./axios";

export interface WeeksResponse {
    readonly id: string;
    readonly exam: boolean;
}

export const callGetWeeks = (id: string) => instance.get<WeeksResponse[]>("api/semesters/" + id + "/weeks");